import React, { useMemo } from 'react';
import { useTsp } from '../context/TspContext';
import { shouldShowAutoPath, shouldShowCustomPath, hasPathsToShow } from '../Services';
// Path display styles are already imported in unified styles
// No need to import './PathDisplay.css' separately

/**
 * Path Legend Component
 * Uses Context API instead of props
 */
const Legend = () => {
  // Get state from context
  const { currentMode, visiblePaths } = useTsp();

  // Destructure paths object
  const autoPath = visiblePaths.auto || [];
  const customPath = visiblePaths.custom || [];

  // Use service functions to calculate visibility
  const showAutoPath = shouldShowAutoPath(currentMode);
  const showCustomPath = shouldShowCustomPath(currentMode);
  
  // Calculate if there is path data to show
  const { hasAutoPaths, hasCustomPaths } = useMemo(() => 
    hasPathsToShow(showAutoPath, showCustomPath, autoPath, customPath),
    [showAutoPath, showCustomPath, autoPath, customPath]
  );

  // Check if there are paths to display, used to show legend
  const showLegend = hasAutoPaths || hasCustomPaths;

  if (!showLegend) return null;

  return (
    <div className="path-legend">
      {hasAutoPaths && (
        <div className="legend-item">
          <div className="legend-line auto"></div>
          <span>Auto Path (Algorithm Solution)</span>
        </div>
      )}
      {hasCustomPaths && (
        <div className="legend-item">
          <div className="legend-line custom"></div>
          <span>Custom Path (Manual Planning)</span>
        </div>
      )}
    </div>
  );
};

export default Legend; 